/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography from "@insite/mobius/Typography";
import React, { useEffect, useState } from "react";
import { GridWrapper } from "@insite/mobius/GridContainer";
import Button, { ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { TypographyProps, TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { getProp } from "@insite/mobius/utilities";
import DeliveryEstimateIcon from "@NA/Icons/DeliveryEstimateIcon";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { StyledButton } from "@insite/mobius/Clickable";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import { connect } from "react-redux";
import { css } from "styled-components";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";


const enum fields {
    pageTitle = "pageTitle",
}

const mapStateToProps = (state: ApplicationState) =>{ 
    
    const billToId = state.context.session.billToId;
    let livechat_accountNumber;
    if (billToId) {
        livechat_accountNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    
   return ({
   isAuthenticated : state.context.session!.isAuthenticated,
    cartPageTitle: getCurrentPage(state).fields.title,
    cart: getCurrentCartState(state).value,
    session: getSession(state),
     liveChatURL: getSettingsCollection(state).customerSettings.liveChatURL,
            livechat_firstName: state.context.session.firstName,
            livechat_lastName: state.context.session.lastName,
            livechat_email: state.context.session.email,
            livechat_accountNumber,
})};

interface CustomProps extends WidgetProps {
    fields: {
        [fields.pageTitle]: string;
    };
}

type Props = WidgetProps & CustomProps & ReturnType<typeof mapStateToProps>;

export interface PageTitleStyles {
    cartLinesLengthContainer?: InjectableCss;
    cartLinesText?: InjectableCss;
    cartLinesLength?: InjectableCss;
    cartPageTitle?: InjectableCss;
    shippingMsgContainer?: InjectableCss;
    shippingMsg?: TypographyProps;
    learnMore?: TypographyProps;
    wrapper?: InjectableCss;
    freeDeliveryPopupModal?: ModalPresentationProps;
    freeDeliveryContainerStyles?: TypographyPresentationProps;
    freeDeliveryBtnContainer?: InjectableCss;
}

export const pageTitleStyles: PageTitleStyles = {
    cartLinesLengthContainer: {
        css: css`
            margin: 20px 0 10px 10px;
            font-size: 20px;
            line-height: 18px;
            color: ${getColor("text.main")};
            font-family: "Nunito Sans", sans-serif;
            display: inline;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    css``,
                    css``,
                    null,
                ])}
        `,
    },
    cartLinesText: {
        css: css`
            font-size: 20px;
            line-height: 18px;
            color: ${getColor("text.main")};
            font-weight: normal;
            font-family: "Nunito Sans", sans-serif;
        `,
    },
    cartLinesLength: {
        css: css`
            font-size: 20px;
            line-height: 18px;
            color: ${getColor("text.main")};
            font-weight: normal;
            font-family: "Nunito Sans", sans-serif;
        `,
    },
    cartPageTitle: {
        css: css`
            display: inline-block;
            color: ${ADIColors.darkBlue1};
            font-size: 36px;
            font-weight: 900;
            font-style: normal;
            font-family: "Nunito Sans", sans-serif;
            line-height: 1.11;
            @media only screen and (max-width: 1024px) {
                font-size: 30px;
            }
            @media only screen and (max-width: 576px) {
                margin-bottom: 10px !important;
            }
        `,
    },
    /* Free shipping */
    shippingMsgContainer: {
        css: css`
            background-color: ${ADIColors.lightblue};
            display: none !important;
            padding: 10px;
            border-radius: 5px;
            text-align: center;
            display: block;
            svg {
                margin-right: 5px;
                transform: scale(0.7) translateY(4px);
            }
            @media screen and (max-width: 576px) {
                display: block !important;
            }    
        `,
    },
    shippingMsg: {
        as: "span",
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            color: ${ADIColors.black};
        `,
    },
    learnMore: {
        as: "span",
        css: css`
            color: ${getColor("primary")};
            padding-left: 3px;
            text-decoration: underline;
            cursor: pointer;
            display: inline-block;
            :hover {
                font-weight: bold;
            }
        `,
    },

    freeDeliveryPopupModal: {
        headlineTypographyProps: {
            variant: "h2",
            css: css`
                font-size: 28px;
                font-weight: 700;
                font-stretch: normal;
                font-style: normal;
                line-height: 36px;
                letter-spacing: normal;
                color: ${ADIColors.darkBlue1};
                border: 0;
                margin-top: 0;
                margin-bottom: 8px;
                padding-bottom: 0;
            `,
        },

        closeButtonProps: {
            css: css`
                padding: 0;
                margin-top: -40px;
                margin-right: -25px;
                &:hover {
                    background: transparent;
                    border-color: transparent;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    width: 35px;
                    height: 35px;
                    > svg {
                        width: 35px;
                        height: 35px;
                        stroke-width: 1.4px;
                    }
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            margin-right: -15px;
                            margin-top: -60px;
                        `,
                        css`
                            margin-right: -15px;
                            margin-top: -40px;
                        `,
                        css`
                            margin-right: -25px;
                            margin-top: -40px;
                        `,
                        null,
                        null,
                    ]);
                }}
            `,
        },
        cssOverrides: {
            headlineTypography: css`
                font-size: 28px;
                line-height: normal;
                margin-bottom: 5px;
             
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                font-size: 24px;
                                line-height: 28px;
                                margin-bottom: 18px;
                                width: 80%;
                            `,
                            css`
                                font-size: 24px;
                                line-height: 1.41;
                                margin-bottom: 18px;
                                width: 80%;
                            `,
                            css`
                                margin-bottom: 18px;
                                width: 80%;
                                font-size: 24px;
                                line-height: 28px;
                            `,
                            css`
                                font-size: 28px;
                               
                                line-height: 38px;
                            `,
                            css`
                                font-size: 28px;
                              
                                line-height: 38px;
                            `,
                        ],
                    );
                }}
            `,
            modalBody: css`
                padding: 34px 27px 27px 27px;
                border-radius: 7px;
                overflow: hidden;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            max-width: calc(100% - 20px);
                            padding: 26px 13px 19px 13px;
                            top: 6%;
                            position: absolute;
                            height: auto;
                            bottom: 5%;
                        `,
                        css`
                            top: 6%;
                            position: absolute;
                            height: auto;
                            height: 90%;
                            max-width: 356px;
                            border-radius: 6px;
                            padding: 26px 13px 19px 13px;
                            bottom: auto;
                        `,
                        css`
                            max-width: 90%;
                            padding: 32px 28px;
                            top: 8%;
                            position: absolute;
                            height: auto;
                        `,
                        css`
                            max-width: 90%;
                            padding: 32px 28px;
                            top: 13%;
                            position: absolute;
                            height: auto;
                        `,
                        css`
                            max-width: 954px;
                            top: 15%;
                            position: absolute;
                            height: auto;
                            margin: 0 auto;
                            padding: 34px 27px 27px 27px;
                        `,
                    ]);
                }}
                ${GridWrapper} {
                    max-width: 100%;
                }
            `,

            modalContent: css`
                padding: 0px;
                overflow: hidden auto;
                &::-webkit-scrollbar {
                    width: 8px;
                }

                &::-webkit-scrollbar-track {
                    background: ${getColor("common.accent")};
                }

                &::-webkit-scrollbar-thumb {
                    background-color: ${ADIColors.lightblue2};
                    border-radius: 7px;
                }
            `,
            modalTitle: css`
                border: unset;
                padding: 0px 10px 0px 0px;
            `,
        },
    },
    freeDeliveryContainerStyles: {
        css: css`
            padding-right: 15px;
            h5 {
                font-size: 18px;
                font-weight: 700;
                color: #2D2926;
                line-height: 28px;
                margin-bottom: 5px;
                margin-top: 5px;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                margin-bottom: 6px;
                            `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            }
            p {
                font-size: 14px;
                color: #2D2926;
                line-height: 24px;
                margin-bottom: 10px;
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                                margin-bottom: 18px;
                            `,
                        css`
                                margin-bottom: 25px;
                            `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            }
            ${StyledButton} {
                > span {
                    color: ${getColor("primary")}!important;
                }
                &:hover {
                    > span {
                        color: ${getColor("primary")}!important;
                        text-decoration: underline;
                    }
                }
            }
        `
    },

    freeDeliveryBtnContainer: {
        css: css`
        text-align: left;
        ${ButtonWrapper} {
            min-width: 160px;
            border-radius: 4px;
            border: 0;
            span {
                font-size: 14px;
                font-weight: 800;
            }
        }
    `,
    },
};

const styles = pageTitleStyles;

const CartPageTitle: React.FunctionComponent<Props> = ({isAuthenticated, cartPageTitle, fields, cart, session, liveChatURL,
    livechat_firstName,
    livechat_lastName,
    livechat_accountNumber,
    livechat_email, }: Props) => {
    const [openShippingDetailsModal, setOpenShippingDetailsModal] = useState(false);
    const [isShippingFree, setIsShippingFree] = useState(false);
    const [amounttoFreeShipping, setAmountToFreeShipping] = useState(0);
    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);

    useEffect(() => {
        const cartValue = typeof cart !== undefined && cart?.orderSubTotal ? cart?.orderSubTotal : 0;
        if (
            (Number(freeShippingAmount) && cartValue > 0 && cartValue >= freeShippingAmount) ||
            freeShippingAmount === 0
        ) {
            setIsShippingFree(true);
        } else {
            setAmountToFreeShipping(freeShippingAmount - cartValue);
            setIsShippingFree(false);
        }
    }, [cart, session]);
    const thresholdAmt: number = +session?.properties["freeshipThresholdAmt"] | 0;

    const closeShippingDetailsModal = () => {
        setOpenShippingDetailsModal(false);
    };


    const handleChat = () => {
        if (isAuthenticated) {
            const popup: string = "popUpWindow";
            const popupParam: string =
                "height=551,width=344,left=100,top=100,resizable=false,scrollbars=false,toolbar=false,menubar=no,location=no,directories=no,status=yes";

            if (liveChatURL) {
                const result =
                    liveChatURL +
                    "firstName=" +
                    livechat_firstName +
                    "&lastName=" +
                    livechat_lastName +
                    "&accountNumber=" +
                    livechat_accountNumber?.toString().replace("-", "") +
                    "&email=" +
                    livechat_email;
                window.open(result, popup, popupParam);
                localStorage.setItem("openLiveChat", "false");
            }
        } 
    };

    return (
        <>
            <Typography variant="h2" as="h1" data-test-selector="CartPageTitle" {...styles.cartPageTitle}>
                {translate(fields.pageTitle || cartPageTitle)}
            </Typography>
            {cart?.cartLines?.length !== 0 ? (
                <StyledWrapper {...styles.cartLinesLengthContainer}>
                    <Typography {...styles.cartLinesLength}>{cart?.cartLines?.length} </Typography>
                    {cart?.cartLines?.length === 1 ? (
                        <Typography {...styles.cartLinesText}>Item</Typography>
                    ) : (
                        <Typography {...styles.cartLinesText}>Items</Typography>
                    )}
                    
                </StyledWrapper>
            ) : (
                ""
            )}
            <StyledWrapper {...styles.shippingMsgContainer}>
                <StyledWrapper as={"span"}>
                    <DeliveryEstimateIcon />
                    <Typography {...styles.shippingMsg}>
                        {isShippingFree ? (
                            <Typography>
                                You get <strong> free delivery </strong> on this order!
                            </Typography>
                        ) : (
                            <Typography>
                                Add {cart?.currencySymbol}
                                {`${amounttoFreeShipping.toFixed(2)}`} more for <strong> free delivery!</strong>
                            </Typography>
                        )}

                        <Typography {...styles.learnMore} onClick={() => setOpenShippingDetailsModal(true)}>
                            Learn more
                        </Typography>
                    </Typography>
                </StyledWrapper>
            </StyledWrapper>
   
            <Modal
                isOpen={openShippingDetailsModal}
                handleClose={closeShippingDetailsModal}
                headline={translate("Pickup and Delivery Terms")}
                sizeVariant="medium"
                {...styles.freeDeliveryPopupModal}
            >
                <StyledWrapper {...styles.freeDeliveryContainerStyles}>
                    {thresholdAmt > 0 && (
                        <Typography variant="p">
                            <Typography as="span">
                                {translate("ThresholdContent1")}&nbsp;
                                {cart?.currencySymbol}
                                {thresholdAmt}&nbsp;
                                {translate("ThresholdContent2")}
                            </Typography>
                        </Typography>
                    )}
                    {thresholdAmt === 0 && (
                        <Typography as="p">
                            <Typography as="span">{translate("ThresholdContent3ForZeroThresoldValue")}</Typography>
                        </Typography>
                    )}

                   {thresholdAmt > 0 && (
                <Typography variant="h5">{translate("Ship Availability")}</Typography>)}
                {thresholdAmt === 0 && (
                    <Typography variant="h5">{translate("Shipping Availability")}</Typography>)}

                    {thresholdAmt > 0 &&
                        <Typography variant="p">
                            {translate("ShipAvailabilityContent1")} <br />
                            {translate("ShipAvailabilityContent2")} &nbsp;
                            {translate("ShipAvailabilityContent5")}
                        </Typography>
                    }
                    {thresholdAmt === 0 &&
                        <Typography variant="p">
                            {translate("ShipAvailabilityContent3")}
                            {translate("ShipAvailabilityContent4")}
                        </Typography>
                    }

                    <Typography variant="h5">{translate("Shipping Costs")}</Typography>

                    {thresholdAmt > 0 && (
                        <Typography variant="p">
                            {translate("ShippingCostsContent1")} <Typography as="span"> {cart?.currencySymbol}{thresholdAmt}</Typography>&nbsp;
                            {translate("ShippingCostsContent2")} &nbsp;<Typography as="span"> {cart?.currencySymbol}{thresholdAmt}</Typography>
                            {translate("ShippingCostsContent3")}  <br />
                            {translate("ShippingCostsContent4")} <Typography as='span' style={{fontWeight: 700}}> {translate("ShippingCostsContent5")}</Typography>&nbsp;
                            {translate("ShippingCostsContent6")} 
                        </Typography>
                    )}
                    {thresholdAmt === 0 && (
                        <Typography variant="p">
                            {translate("ShippingCostsContent5ForZeroThresoldValue")}
                            <br />

                            {translate("ShippingCostsContent6ForZeroThresoldValue")}
                        </Typography>
                    )}
                    {thresholdAmt > 0 && (
                                      <Typography variant="h5">{translate("Free Store Pickup Options")}</Typography> )}
                                        {thresholdAmt === 0 && (
                                      <Typography variant="h5">{translate("Free Store Pickup")}</Typography> )}
                                     
                    {thresholdAmt > 0 && <Typography variant="p">
                        {translate("FreeBranchPickupContent1")}
                        {translate("FreeBranchPickupContent2")}&nbsp;
                        {translate("FreeBranchPickupContent3")}

                    </Typography>}

                    {thresholdAmt === 0 && <Typography variant="p">
                        {translate("FreeBranchPickupContent5")}

                    </Typography>}
                    {thresholdAmt > 0 &&
                        <>
                            <Typography variant="h5">{translate("* Exclusions:")}</Typography>

                                  <Typography variant="p">
                                        {translate("Exclusions1")} &nbsp;
                                        {translate("Exclusions2")} 
                           
                                    </Typography>
                                    <Typography variant="p">
                                  
                                        {translate("Exclusions3")} 
                                    </Typography>
        
        
                                    <Typography variant="p">
                                        <Link href="/flat_rate_shipping">{translate("Learn more ")}</Link>&nbsp;
                                        {translate("Exclusions4")}
                                    </Typography>
                        </>
                    }
                    {thresholdAmt === 0 &&
                        <>
                            <Typography variant="h5">{translate("Exceptions:")}</Typography>
                            <Typography variant="p">

                                {translate("Exclusions5")}
                                {translate("Exclusions6")}

                            </Typography>

                            <Typography variant="p">
                                <Link href="/flat_rate_shipping">{translate("Learn more ")}</Link>&nbsp;
                                {translate("Exclusions7")}
                            </Typography>
                        </>
                    }

                    {thresholdAmt > 0 &&
                        <>
                            <Typography variant="h5">{translate("Questions?")}</Typography>
                            <Typography variant="p">
                                {translate("QuestionsContent1")}&nbsp;
                                <Link onClick={handleChat}>{translate(" chat with us ")}</Link> &nbsp;
                                {translate("QuestionsContent2")}&nbsp;
                            </Typography>
                        </>
                    }
                    {thresholdAmt === 0 &&
                        <>
                            <Typography variant="h5">{translate("Need Help?")}</Typography>
                            <Typography variant="p">
                                {translate("QuestionsContent3")}&nbsp;
                                <Link onClick={handleChat}>{translate(" chat with us ")}</Link> &nbsp;
                                {translate("QuestionsContent2")}&nbsp;
                            </Typography>
                        </>
                    }
                    <StyledWrapper {...styles.freeDeliveryBtnContainer}>
                        <Button onClick={closeShippingDetailsModal}>Close</Button>
                    </StyledWrapper>
                </StyledWrapper>
            </Modal>
        </>
    );
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps,)(CartPageTitle),
    definition: {
        group: "Basic",
        icon: "PageTitle",
        fieldDefinitions: [
            {
                name: fields.pageTitle,
                displayName: "Page Title Overrided",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
